import environment from '../environment';

export interface AskAQuestionProps {
    gender: string;
    firstName: string;
    lastName: string;
    email: string;
    message: string;
    areaId: string;
    regionId?: string;
    projectId?: string;
    propertyTypeId?: string;
    districtId?: string;
    lastNamePrefix?: string;
    refererUrl?: string;
    contactReason: string;
    complaintType?: string;
    phoneNumber?: string;
    webcareSubject?: string;
    chatUrl?: string;
    appointmentSelection?: string;
    isAppointmentForm?: boolean;
    url?: string;
}

const ENDPOINT = '/umbraco/api/AjaxForm/SubmitAskAQuestionForm';

export const askAQuestion = async ({
    regionId,
    projectId,
    propertyTypeId,
    areaId,
    districtId,
    lastNamePrefix,
    firstName,
    lastName,
    email,
    message,
    refererUrl,
    contactReason,
    complaintType,
    phoneNumber,
    webcareSubject,
    chatUrl,
    appointmentSelection,
    isAppointmentForm,
    url,
}: AskAQuestionProps) => {
    const data: any = {
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        Message: message,
        AreaId: areaId,
    };

    if (regionId) data.RegionId = regionId;
    if (projectId) data.ProjectId = projectId;
    if (propertyTypeId) data.PropertyTypeId = propertyTypeId;
    if (districtId) data.DistrictId = districtId;
    if (lastNamePrefix) data.LastNamePrefix = lastNamePrefix;
    if (refererUrl) data.RefererUrl = refererUrl;
    if (contactReason) data.ContactReason = contactReason;
    if (complaintType) data.ComplaintType = complaintType;
    if (phoneNumber) data.PhoneNumber = phoneNumber;
    if (webcareSubject) data.WebcareSubject = webcareSubject;
    if (chatUrl) data.ChatUrl = chatUrl;
    if (appointmentSelection) data.AppointmentSelection = appointmentSelection;
    if (isAppointmentForm) data.IsAppointmentForm = isAppointmentForm;
    if (url) data.Url = url;

    if (environment.isLocal) {
        console.log(data);
    }

    await fetch(ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
};
